import { IMethodData } from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';

import { setPaymentMethods } from '~/src/features/payments-abn/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const cardMethods = ['card', 'new-card'];
const isCardMethod = (method: IMethodData) => {
    return cardMethods.includes(method.methodType);
};

/**
 * Добавление методов оплаты новой и сохраненными картами
 * Если передан пустой массив методы удаляются
 */
export const addCardMethods = (newCardMethods: IMethodData[]) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const state = getState();
        const currentMethods = state.payment.methods;
        const currentCardMethods = currentMethods.filter(isCardMethod);

        // Добавляем сохраненные карты
        if (currentCardMethods.length === 0 && newCardMethods.length) {
            dispatch(setPaymentMethods([...currentMethods, ...newCardMethods]));
            return;
        }

        if (currentCardMethods.length) {
            const currentCardElementIndex = currentMethods.findIndex(isCardMethod);

            if (currentCardElementIndex >= 0) {
                const prevElements = currentMethods.slice(0, currentCardElementIndex);
                const afterElements = currentMethods.slice(currentCardElementIndex).filter(el => !isCardMethod(el));

                const newCardsIds = newCardMethods.map(el => el.id).sort().join('');
                const currentCardsIds = currentCardMethods.map(el => el.id).sort().join('');

                // Заменяем сохраненные карты
                if (newCardsIds !== currentCardsIds) {
                    dispatch(setPaymentMethods([...prevElements, ...newCardMethods, ...afterElements]));
                }
            }
        }
    };
};

/**
 * Добавление методов оплаты, кроме методов оплаты картой
 */
export const addNewPayMethods = (newMethods: IMethodData[]) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const state = getState();
        const currentMethods = state.payment.methods;

        // Добавляем новые методы оплаты
        const currentMethodsIds = currentMethods.map(el => el.id);
        const noExistMethods = newMethods.filter(el => !currentMethodsIds.includes(el.id));

        if (noExistMethods.length) {
            dispatch(setPaymentMethods([...currentMethods, ...noExistMethods]));
        }
    };
};

export default addNewPayMethods;
